import '@babel/polyfill';
import { navigateAction } from 'fluxible-router';
import { createElementWithContext } from 'fluxible-addons-react';
import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { extractNetworkName, extractSpotId } from './scripts/services/extract-url';
import { setupInterceptors } from './scripts/resources';
import { initializeContext } from './scripts/state/fluxible-context';
import me from '@spotim/fed-resources/resources/me';
import { setNetwork, setSpotId, setToken } from 'app/scripts/services/app-state';
import queryString from 'utils/query-string';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import reduxStore from 'state';
import initializeApp from 'app/scripts/state/app-state/actions/init-app';
import './styles/index.scss';
import { configureSendEvents } from '@spotim/send-events';

/* eslint-disable no-undef, no-undef-init */
async function initialize() {
  let network, token;
  let url = window.location.href;
  let spotId = extractSpotId();

  // We are setting node env on window to support launcher across app.
  const nodeEnv = process.env.NODE_ENV || 'production';
  window.__SPOTIM_ENV__ = nodeEnv;
  window.__SPOTIMENV__ = nodeEnv;

  window.React = React; // For chrome dev tool support

  if (typeof HOST_PANEL_VERSION === 'string' && typeof DEPLOY_DATE === 'string') {
    console.log(
      `OpenWeb Host Panel Module version ${HOST_PANEL_VERSION.trim()} deployed at ${DEPLOY_DATE}`
    );
  }

  if (process.env.NODE_ENV !== 'production' && typeof NODE_VERSION === 'string') {
    console.log('Node Version: ', NODE_VERSION);
  }

  try {
    token = queryString.getKey(url, 'token');
    let networkName = queryString.getKey(url, 'network_name');
    let isSuperAdmin = token && networkName;

    if (!isSuperAdmin) {
      if (spotId) {
        let {
          body: { network_name: netName }
        } = await me.getNetworkIdBySpotId(spotId);
        networkName = netName;
      } else {
        networkName = extractNetworkName();
      }
    }

    let { body } = await me.getNetworkIdByName(networkName);
    if (body.success === false) {
      throw `No such network name: ${networkName}`;
    }
    network = body;
    if (!token) {
      let { body } = await me.fetchNetworkToken(network.network_id);
      token = body.token;
    }

    setSpotId(spotId);
    setNetwork(network);
    setToken(token);
    setupInterceptors(spotId, network.network_id);
  } catch (error) {
    console.error(error);
    ErrorNotifier.notifyError(error);
  }

  url = url.substring(url.indexOf(window.location.host));
  url = url.substring(window.location.host.length);

  const context = initializeContext();
  const store = reduxStore.init();

  configureSendEvents({
    url: 'https://events-collector.spot.im/api/v1/admin-panel-events'
  });

  context.executeAction(navigateAction, { url, type: 'pageload' }, async function (err) {
    try {
      if (err) {
        throw err;
      }

      // Stores
      window.context = context;
      window.__SPOTIM_HP_STORE__ = store;

      await store.dispatch(initializeApp({ spotId, network, token }));

      // Sentry
      ErrorNotifier.Initialize();

      ReactDOM.render(
        <Provider store={store}>{createElementWithContext(context)}</Provider>,
        document.getElementById('app')
      );
    } catch (e) {
      console.error(e);
      ErrorNotifier.notifyError(e);
    }
  });
}

initialize();
